/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { animals, colors, Config, names, NumberDictionary, uniqueNamesGenerator } from "unique-names-generator";

const numberDictionary = NumberDictionary.generate({ min: 0, max: 999, length: 3 });

const customConfig: Config = {
  dictionaries: [names, ["the"], colors, animals, numberDictionary],
  separator: "-",
  length: 5,
  style: "lowerCase"
};

export const createUniqueName = (maxLength?: number): string => uniqueNamesGenerator(customConfig).substring(0, maxLength);
